<template>
    <div>
        <div class="xinz">
            <div class="right">
                <router-link tag='a' :to="'/rollAdd'" style="text-decoration: none;color: #fff;"><el-button type="warning" v-if="canAdd"><i class="fa fa-plus" /> {{$t('m.t_newRolling')}}</el-button></router-link>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getFeedBackList" size="small">
                <el-form-item label="車號">
                    <el-input placeholder="車號"  v-model="serchCarNumber" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                            v-model="getFeedDate"
                            type="date"
                            placeholder="選擇日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item >
                    <el-select v-model="serchStatus" placeholder="狀態" style="width:150px;" clearable>
                        <el-option value="0" label="未出倉"></el-option>
                        <el-option value="1" label="已出倉"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getFeedBackList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    @selection-change="handleSelectionChange"
                    :data="rollingList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    class="dataListTable">

                <el-table-column
                    prop="feedDate"
                    align="left"
                    width="110"
                    :label="$t('m.t_date')">
                <template slot-scope="scope">
                    <template v-if="scope.row.feedDate!=0 && scope.row.feedDate!='' && scope.row.feedDate!=null">
                        {{scope.row.feedDate*1000 | date('%Y-%m-%d') }}
                    </template>
                </template>
            </el-table-column>
                <el-table-column
                        prop="carNumber"
                        align="left"
                        width="140"
                        label="車號">
                </el-table-column>
                <el-table-column
                        prop="internal"
                        align="left"
                        label="內部備註">
                </el-table-column>

                <el-table-column
                        prop="outDate"
                        align="left"
                        width="140"
                        label="出倉時間">
                    <template slot-scope="scope">
                        <template v-if="scope.row.outDate!=0 && scope.row.outDate!='' && scope.row.outDate!=null">
                            {{scope.row.outDate*1000 | date('%Y-%m-%d %H:%M') }}
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="outBy"
                        align="left"
                        width="100"
                        label="出倉人">
                </el-table-column>

                <el-table-column
                        prop="storageDate"
                        align="left"
                        width="140"
                        label="入倉時間">
                    <template slot-scope="scope">
                        <template v-if="scope.row.storageDate!=0 && scope.row.storageDate!='' && scope.row.storageDate!=null">
                            {{scope.row.storageDate*1000 | date('%Y-%m-%d %H:%M') }}
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="storageBy"
                        align="left"
                        width="100"
                        label="入倉人">
                </el-table-column>
                <el-table-column
                        prop="status"
                        align="left"
                        width="80"
                        label="狀態">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status==0">
                            未出倉
                        </template>
                        <template v-if="scope.row.status==1">
                            <template v-if="scope.row.feeStatus==0">
                                已出倉
                            </template>
                            <template v-if="scope.row.feeStatus==1">
                                已入倉
                            </template>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="rollingEdit(scope.row)" v-if="canEdit && scope.row.status==0"><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="deleteEdit(scope.row)" v-if="canDelete && scope.row.status==0"><i class="fa fa-edit"/>刪除</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="rollingEdit(scope.row)" v-if="canEdit && scope.row.status==1"><i class="fa fa-edit"/>查看出倉</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="feedEdit(scope.row)" v-if="canIn &&scope.row.status==1 && scope.row.feeStatus==0"><i class="fa fa-edit"/>入倉</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="feedEdit(scope.row)" v-if="canIn && scope.row.status==1 && scope.row.feeStatus==1"><i class="fa fa-edit"/>查看入倉</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pdfDownload(scope.row)" v-if="canPdf"><i class="fa fa-file-pdf-o"/>PDF</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getRollingsList,deleteRollingById} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查詢條件
                serchCarNumber:"",
                serchStatus:'',
                getFeedDate:'',
                selectionItems:[],
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                rollingList:[],
                dialogName:'',
                tableloading:false,
            }
        },
        methods: {
            removeRollItem(index){
                let i=0;
                for(i;i<this.poiItemList.length;i++){
                    if(index==this.poiItemList[i].index){
                        break;
                    }
                }
                this.poiItemList.splice(i,1);
                this.rearrIndex();
            },
            //當發票商品刪除的時候， 重新給每個index 賦值
            rearrIndex(){
                let i = 0;
                for(i=0;i<this.poiItemList.length;i++){
                    this.poiItemList[i].index = i+1;
                }
                this.index = i;
            },
            deleteEdit(row){
                this.$confirm('你確定要刪除嗎?',this.$t('m.m_info'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(()=> {
                    deleteRollingById(row.id).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            this.$message.success('刪除成功');
                            this.getFeedBackList();
                        }else{
                            this.$message.error("刪除失败！");
                        }
                    });
                });
            },
            handleSelectionFileChange(){},
            handleFileListChange(val){
            },

            custTaskPageChange(val){
                this.getFeedBackList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            pdfDownload(value){
                var url=axios.defaults.baseURL+"/excel/rollStock?rollId="+value.id+"&token="+ this.$store.getters.staff.token;
                window.location.href=url;
            },
            getFeedBackList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,carNumber:this.serchCarNumber.trim(),feedDate:this.getFeedDate,status:this.serchStatus};
                if(params.feedDate!=null && params.feedDate!=''){
                    params.feedDate = parseInt(new Date(params.feedDate).getTime()/1000);
                }
                return getRollingsList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.rollingList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            rollingEdit(row){
                this.$router.push({
                    name:'編輯出倉紙',
                    params:{
                        outId:row.id
                    }
                })
                var path="/rollEdit/"+row.id
                this.$router.push(path);
            },
            feedEdit(row){
                this.$router.push({
                    name:'編輯回料紙',
                    params:{
                        feedId:row.feeId,
                        rollId:row.id
                    }
                })
                var path="/feedEdit/"+row.feeId+"/"+row.id
                this.$router.push(path);
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getFeedBackList();

        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("ROLL_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("ROLL_EDIT");
            },
            canPdf(){
                return this.$store.getters.hasPermission("ROLL_PDF");
            },
            canDelete(){
                return this.$store.getters.hasPermission("ROLL_DELETE");
            },
            canIn(){
                return this.$store.getters.hasPermission("ROLL_IN");
            },
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/RollingList.vue